/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import'rxjs/add/operator/map';

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {DatagridPropertyComparator} from '../built-in/comparators/datagrid-property-comparator';
import {DatagridPropertyStringFilter} from '../built-in/filters/datagrid-property-string-filter';
import {DatagridStringFilterImpl} from '../built-in/filters/datagrid-string-filter-impl';
import {State} from '../interfaces/state';

import {FiltersProvider} from './filters';
import {Page} from './page';
import {Sort} from './sort';
import {StateDebouncer} from './state-debouncer.provider';
/**
 * This provider aggregates state changes from the various providers of the Datagrid
 */
export class StateProvider {
/**
 * @param {?} filters
 * @param {?} sort
 * @param {?} page
 * @param {?} debouncer
 */
constructor(private filters: FiltersProvider,
private sort: Sort,
private page: Page,
private debouncer: StateDebouncer) {}
/**
 * The Observable that lets other classes subscribe to global state changes
 */
change: Observable<State> = this.debouncer.change.map(() => this.state);
/**
 * @return {?}
 */
get state(): State {
        const /** @type {?} */ state: State = {};
        if (this.page.size > 0) {
            state.page = {from: this.page.firstItem, to: this.page.lastItem, size: this.page.size};
        }
        if (this.sort.comparator) {
            if (this.sort.comparator instanceof DatagridPropertyComparator) {
                /*
                 * Special case for the default object property comparator,
                 * we give the property name instead of the actual comparator.
                 */
                state.sort = {by: ( /** @type {?} */((<DatagridPropertyComparator>this.sort.comparator))).prop, reverse: this.sort.reverse};
            } else {
                state.sort = {by: this.sort.comparator, reverse: this.sort.reverse};
            }
        }

        const /** @type {?} */ activeFilters = this.filters.getActiveFilters();
        if (activeFilters.length > 0) {
            state.filters = [];
            for (const /** @type {?} */ filter of activeFilters) {
                if (filter instanceof DatagridStringFilterImpl) {
                    const /** @type {?} */ stringFilter = ( /** @type {?} */((<DatagridStringFilterImpl>filter))).filterFn;
                    if (stringFilter instanceof DatagridPropertyStringFilter) {
                        /*
                         * Special case again for the default object property filter,
                         * we give the property name instead of the full filter object.
                         */
                        state.filters.push({
                            property: ( /** @type {?} */((<DatagridPropertyStringFilter>stringFilter))).prop,
                            value: ( /** @type {?} */((<DatagridStringFilterImpl>filter))).value
                        });
                        continue;
                    }
                }
                state.filters.push(filter);
            }
        }
        return state;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FiltersProvider, },
{type: Sort, },
{type: Page, },
{type: StateDebouncer, },
];
}

function StateProvider_tsickle_Closure_declarations() {
/** @type {?} */
StateProvider.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StateProvider.ctorParameters;
/**
 * The Observable that lets other classes subscribe to global state changes
 * @type {?}
 */
StateProvider.prototype.change;
/** @type {?} */
StateProvider.prototype.filters;
/** @type {?} */
StateProvider.prototype.sort;
/** @type {?} */
StateProvider.prototype.page;
/** @type {?} */
StateProvider.prototype.debouncer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
